module.exports = __webpack_public_path__ + "img/practicaadecuada.46cc9313.png";